import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import ButtonComp from "../Button";
import "./styles.css";
import { Grid } from "@material-ui/core";

export default function DialogComponent(props) {
  const { openPopup, popuptitle, popupContent, buttonValue, extraContent } =
    props;

  return (
    <div className="dialogPopupCls">
      <Dialog
        open={openPopup}
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: "100%",
              maxWidth: "500px", 
            },
          },
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle
          id="alert-dialog-title"
          className="dialog-titleCls"
          sx={{
            letterSpacing: "0px",
            color: "#000000",
            fontSize: "20px",
            lineHeight: "1.4",
            padding: "7%",
            fontWeight: '600',
          }}
        >
          {popuptitle}
        </DialogTitle>
        <DialogContent sx={{ padding: "0px 7%" }}>
          <DialogContentText
            id="alert-dialog-description"
            sx={{
              fontSize: "14px",
              letterSpacing: "0px",
              color: "#000000",
              // color: "#535353",
            }}
          >
            {popupContent}
            {extraContent && extraContent()}
          </DialogContentText>
        </DialogContent>
        <DialogActions
          sx={{
            padding: "7%",
          }}
        >
          {buttonValue.length !== 0 &&
            buttonValue.map((item) => (
              <Grid
                style={
                  {
                    // border:'1px solid red',
                    // marginLeft: "7%",
                  }
                }
              >
                <ButtonComp
                  color={item.color}
                  sx={{ fontWeight: item.fontWeight,fontfamily: item.fontfamily }}
                  onClick={item.functionCall}
                  name={item.value}
                />
              </Grid>
            ))}
        </DialogActions>
      </Dialog>
    </div>
  );
}
